<template>
  <div class="container m-b-4">
    <div class="CONTENT">
      <template v-for="(nav, index) in $options.NAV_CONFIG">
        <div
            class="ITEM cur-not-allowed"
            v-if="index > sequenceNumber"
            :key="nav.name"
            :selenium="nav.selenium">
          <div class="TRIANGLES"/>
          <span class="SHORT-TEXT">{{ nav.shortText }}</span>
          <span class="LONG-TEXT">{{ nav.longText }}</span>
        </div>
        <router-link
            v-else
            :key="nav.name"
            :to="{
              name: nav.name,
              query: $route.query,
            }"
            :selenium="nav.selenium"
            active-class="ITEM--ACTIVE"
            class="ITEM">
          <div class="TRIANGLES"/>
          <span class="SHORT-TEXT">{{ nav.shortText }}</span>
          <span class="LONG-TEXT">{{ nav.longText }}</span>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
const NAV_CONFIG = [
  {
    name: 'jobrequest::details',
    longText: 'Add Project Details',
    shortText: 'Step 1',
    selenium: 'Add-Project-Details-Link',
  },
  {
    name: 'jobrequest::matches',
    longText: 'Find My Pros',
    shortText: 'Step 2',
    selenium: 'Find-My-Pros-Link',
  },
  {
    name: 'jobrequest::overview',
    longText: 'Submit My Requests',
    shortText: 'Step 3',
    selenium: 'Submit-My-Request-Link',
  },
];

export default {
  name: 'navigation',
  NAV_CONFIG,
  computed: {
    sequenceNumber () {
      return NAV_CONFIG.findIndex(config => this.$route.name === config.name);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

$navigation-triangle-size: 48px;
$navigation-triangle-width: 24px;

%Navigation-triangle {
  @include square(0);
  @include absolute(50%, auto, auto, auto);
  display: block;
  border-top: $navigation-triangle-size solid transparent;
  border-bottom: $navigation-triangle-size solid transparent;
  transform: translateY(-50%);
  content: '';
}

.CONTENT {
  display: flex;
  max-width: $tablet;
  position: relative;
}

.LONG-TEXT {
  display: none;
  position: relative;
  z-index: 3;

  @include tablet() {
    display: block;
  }
}

.SHORT-TEXT {

  display: block;
  position: relative;
  z-index: 3;
  @include tablet() {
    display: none;
  }
}

.SHORT-TEXT,
.LONG-TEXT {
  font-weight: bold;

  &:after {
    $navigation-dot-size: 16px;

    @include absolute(auto, auto, - ($navigation-dot-size/2), 50%);
    @include square($navigation-dot-size);

    content: '';
    background-color: $color-gray20;
    display: block;
    transform: translateX(-50%);
    border-radius: 50%;
    border: 3px solid white;
  }
}

.ITEM {
  @include text-small();
  @include remove-link-styles($color: $color-gray40);
  display: block;
  position: relative;
  height: ($unit * 6);
  line-height: ($unit * 6) !important; // override text-*() mixin's line height
  text-align: center;
  padding-left: 10px + $navigation-triangle-width;
  padding-right: 10px;

  @include tablet() {
    @include text-medium();
    flex: 1;
    padding-right: 0;
  }

  &:hover {
    color: $color-gray70;
  }

  &:last-child {
    .TRIANGLES {
      right: 0;

      &:after {
        display: none;
      }
    }
  }

  &.ITEM--ACTIVE {
    flex: 1;
    color: white;
    cursor: default;
    background-color: $color-depot;
    padding-right: 0;

    .TRIANGLES:after {
      border-left-color: $color-depot;
    }

    .TRIANGLES:before {
      display: none;
    }

    & + .ITEM {
      .TRIANGLES:before {
        display: none;
      }
    }

    .LONG-TEXT:after {
      background-color: $color-depot;
    }

    .LONG-TEXT {
      display: block;
    }

    .SHORT-TEXT {
      display: none;
    }

    &:first-of-type {
      padding-left: 10px;
    }
  }

  &:first-of-type {
    padding-left: 10px;
    .TRIANGLES:before {
      display: none;
    }
  }
}

.TRIANGLES {
  @include absolute(0, -$navigation-triangle-width, 0, 0);
  overflow: hidden;

  &:after {
    @extend %Navigation-triangle;
    right: 0;
    border-left: $navigation-triangle-size solid white;
    z-index: 2;
  }

  &:before {
    @extend %Navigation-triangle;
    left: - ($navigation-triangle-width - 1); // offset by 1px to simulate border
    border-left: $navigation-triangle-size solid $color-gray20;
    z-index: 1;
  }
}
</style>
